import {Button} from '@/components/ui/button';
import {Gift, Code2} from 'lucide-react';

interface InfoBannerProps {
    onOpenCodeBuilder: () => void;
}

export const InfoBanner = ({onOpenCodeBuilder}: InfoBannerProps) => {
    return (
        <div className="rounded-lg bg-gradient-to-r from-blue-50 to-indigo-50 border border-blue-200 p-6">
            <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-4 flex-1">
                    <div className="flex-shrink-0 h-12 w-12 bg-blue-600 rounded-full flex items-center justify-center">
                        <Gift className="h-6 w-6 text-white"/>
                    </div>
                    <div>
                        <h3 className="font-semibold text-blue-900">Como funciona?</h3>
                        <p className="text-sm text-blue-700 mt-1">
                            Crie rewards personalizados com preview em tempo real. As traduções são geradas
                            automaticamente para múltiplos idiomas.
                        </p>
                    </div>
                </div>
                <Button
                    variant="outline"
                    size="sm"
                    onClick={onOpenCodeBuilder}
                    className="flex-shrink-0 bg-white hover:bg-blue-50 border-blue-300"
                >
                    <Code2 className="h-4 w-4 mr-2"/>
                    Gerar Código
                </Button>
            </div>
        </div>
    );
};